import React , {useRef}from "react"
import {  MicOutlined } from '@mui/icons-material'
import {  Button } from '@mui/material'
import styled from 'styled-components';
import { useComponentVisible } from "./hooks";
import COLOR from 'utils/constants/color';
import AudioRecorderNew from "features/AudeoRecorderNew";
import fiMicrophoneSvg from "../../utils/assets/images/fi-microphone.svg";

const AudioRecorderButton = styled.button`
    border: none;
    background-color: transparent;
    cursor: pointer;
`;
const EmojiWrapper = styled.div`
  position: absolute;
  bottom: ${p=>p.bottom?p.bottom:"60px"};
  overflow: visible;
  width: 300px;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  box-shadow: rgb(0 0 0 / 51%) 20px 20px 60px;
  z-index: 999999;
  ${p=>p.$is_report_issue && "left: 0px !important;"}
  @media (max-width: 991px) {
      left: 0px;
  }
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`
export default function Audio({ onRecorderDone , bottom="60px", hasBoxShadow=false, type="", storageLoc , from="", is_report_issue=false}) {
    const {
        ref,
        isComponentVisible,
        setIsComponentVisible
    } = useComponentVisible(false);
  const recorder = useRef()
  const isChat = type === "isChat"
    return (
        <Wrapper className="AudioRecorderCstm">
            {isComponentVisible && (
                <EmojiWrapper style={{left: isChat && "-2px", width: isChat && "232px"}} ref={ref} bottom={bottom}  $is_report_issue={is_report_issue}>
                     <AudioRecorderNew  
                     wrapperStyle={{borderBottom:'0px'}}
                       message={`To begin your recording click the "Record" button below.`}
                       doneButton={<Button onClick={() =>setIsComponentVisible(false)} 
                       style={{ marginLeft: '8px' }}>Done</Button>}
                       ref={recorder} 
                       handleAudio={onRecorderDone}
                       type={type}
                       from={from}
                       storageLoc={storageLoc}
                       />
                </EmojiWrapper>
            )}

            {/* <AudioRecorderButton onClick={() => setIsComponentVisible(true)}>
               <MicOutlined  style={{ color: COLOR.lightseagreen200 }} />
            </AudioRecorderButton> */}

            <div className='textAreaIconsBg'>
              <div onClick={() => setIsComponentVisible(true)}><img src={fiMicrophoneSvg} alt="" title="" /></div>
            </div>
        </Wrapper>
    );
}
